import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_PROGRAM_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => ({ ...oldDoc, enabledExamTypes: [] }),
  3: (oldDoc) => ({ ...oldDoc, enabledDeviceIds: [] }),
};
